




































import { Component, Vue, Prop } from "vue-property-decorator";
import Task from "../models/task";
import moment from "moment";

@Component({})
export default class TaskListItem extends Vue {
  @Prop({ required: true }) task!: Task;
  @Prop({ required: true }) canEdit!: false;

  get dueDateClassName() {
    if (!this.task.dueDateVariant) return "";
    return `text-${this.task.dueDateVariant}`;
  }

  get colorByTaskDeadline() {
    if (new Date().getTime() >= new Date(this.task.dueDate).getTime()) {
      return "task-overdue";
    }

    if (moment(this.task.dueDate).isBefore(moment().add(4, "days"), "day")) {
      return "task-near-deadline";
    }

    return "";
  }

  edit(task: Task) {
    this.$emit("edit", task);
  }

  toggle(done: boolean) {
    this.$emit("toggle", done);
  }
}
